import React, { useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";

import {
  LargeButton,
  MainBody,
  PageTitle,
  RadioCardList,
} from "components/core";
import { SideNav } from "components";
import { Error, WidthLimiter } from "./styles";
import { INSURANCE_PRODUCTS } from "constants";
import { selectedInsuranceProductIndices } from "state/planSetup";
import useNavigateInsuranceSetup from "hooks/useNavigateInsuranceSetup";

const InsuranceSetup = () => {
  // custom hook to handle insurance product navigation
  const { navigateInsurancePlan } = useNavigateInsuranceSetup();
  // selected products
  const [selectedCards, setSelectedCards] = useState([]);
  // error state
  const [showError, setShowError] = useState(false);
  // global selected indices
  const setSelectedIndices = useSetRecoilState(selectedInsuranceProductIndices);

  // to check whether any cards are selected or not
  const noCardsSelected = selectedCards.length === 0;

  const onChange = (selectedCards) => {
    // hiding error on card selection
    setShowError(false);
    // storing cards globally
    setSelectedCards([...selectedCards]);
  };

  useEffect(() => {
    // resetting storage
    resetStorage();
  }, []);

  const resetStorage = () => {
    // resetting marked_products
    localStorage.removeItem("marked_products");
    // resetting userplan_ids received from posting the data to backend
    localStorage.removeItem("userplan_ids");
    localStorage.removeItem("gmc_done")
  };

  // handling submission
  const onSubmit = () => {
    // displaying error and returning if no cards are selected
    if (noCardsSelected) {
      setShowError(true);
      return;
    }
    // setting selected products globally
    setSelectedIndices(selectedCards);
    // navigating to next product page
    navigateInsurancePlan();
  };

  return (
    <section>
      <SideNav />
      <MainBody>
        <WidthLimiter>
          <div
            style={{
              height: "88vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <div>
              <PageTitle title="Select Benefits" />
              <RadioCardList list={INSURANCE_PRODUCTS} onChange={onChange} />
              {showError && (
                <Error>
                  At least a single Insurance Product has to be selected!
                </Error>
              )}
            </div>
            <div style={{ marginTop: "4rem" }}>
              <LargeButton
                label="Save & Next"
                marginTop="2rem"
                onClick={onSubmit}
              />
            </div>
          </div>
        </WidthLimiter>
      </MainBody>
    </section>
  );
};

export default InsuranceSetup;
